// extracted by mini-css-extract-plugin
export var btn = "F_mB q_rq q_q5 d_bz d_bP d_bD d_dw";
export var full = "F_vW d_w d_H";
export var hoverStyle = "F_mF";
export var zoom = "F_mG";